name: Tooling
quadrant: 0
entries:
  - label: npm
    description: >
      <a href="https://www.npmjs.com/">npm</a> is a widely-used package manager
      for JavaScript that helps developers install, share, and manage code
      dependencies for Node.js projects.

      However, it is not recommended to use npm; instead, we suggest using pnpm
      for better performance and efficiency. With the addition of Corepack, npm
      is no longer the default Node package manager.
    ring: onHold
    active: true
    moved: 0
  - label: pnpm
    description: >
      <a href="https://pnpm.io/">pnpm</a> is a fast, disk space-efficient
      package manager for JavaScript that uses a unique approach to manage
      dependencies by creating a global store for packages.

      It is the recommended package manager due to its efficiency and
      performance, and it is widely used and battle-tested in our existing
      projects.
    ring: adopt
    active: true
    moved: 0
  - label: yarn
    description: >
      <a href="https://classic.yarnpkg.com/">Yarn</a> Yarn is a package manager
      for JavaScript that offers fast and reliable dependency management with
      features like offline caching and deterministic installs.

      However, it is not recommended to use Yarn; instead, we suggest using PNPM
      for better performance and efficiency in managing dependencies.
    ring: onHold
    active: true
    moved: 0
  - label: composer
    description: >
      <a href="https://getcomposer.org/">Composer</a> Composer is a dependency
      management tool for PHP that handles libraries and packages, ensuring
      smooth integration and version control within projects.

      It is the default method for managing packages in our PHP-based projects.
    ring: adopt
    active: true
    moved: 0
  - label: Webpack
    description: >
      <a href="http://webpack.github.io/">Webpack</a> is a powerful module
      bundler for JavaScript applications that enables developers to bundle and
      optimize assets such as JavaScript, CSS, and images.

      It is not recommended to use Webpack for new projects; instead, more
      modern bundlers like Vite, which require less configuration and setup, are
      preferred. If you need to migrate away from Webpack or start a new
      project, please contact your area architect for support and guidance.
    ring: onHold
    active: true
    moved: 0
  - label: vite
    description: >
      <a href="https://vitejs.dev/">vite</a> is a modern build tool that
      provides a fast and efficient development experience, especially
      well-suited for building TypeScript applications, including those using
      React.

      It is recommended for writing apps in TypeScript and has been successfully
      implemented in multiple projects, demonstrating its reliability and
      effectiveness.
    ring: adopt
    active: true
    moved: 0
  - label: jest
    description: >
      <a href="https://jestjs.io/">jest</a> is a powerful Javascript testing
      framework that supports running tests in a (virtuell) browser environment
      as well as in Node.js. It is a very efficient and feature packed test
      runner that supports TypeScript, React and other technologies out of the
      box.

      We recommend using jest as your default test runner for Javascript and
      Typescript based projects.
    ring: adopt
    active: true
    moved: 0
  - label: Cypress
    description: >
      <a href="https://cypress.io/">Cypress</a> is an end-to-end testing
      framework that offers a robust and user-friendly solution for automating
      and verifying web application functionality.

      It is recommended for writing end-to-end tests and has proven to be
      reliable in large projects, ensuring thorough and consistent test
      coverage.
    ring: adopt
    active: true
    moved: 0
  - label: Behat
    description: >
      <a href="https://behat.org/">Behat</a> is a PHP testing framework which
      can be used to automate acceptance tests in a human readable language
      called Gherkin. Since it is based on Cucumber, it also helps teams to
      adopt and implement Behavioral Driven Development (BDD).

      While Behat is still a good solution, other frameworks like Cypress are
      more feature rich and developer friendly. We recommend to use an
      alternative like Cypress for new projects.
    ring: onHold
    active: true
    moved: 0
  - label: Matomo
    description: >
      <a href="https://matomo.org/">Matomo</a> is an open-source web analytics
      platform that delivers comprehensive insights into user behavior, website
      performance, and engagement while maintaining a strong focus on data
      privacy and compliance.

      Matomo is currently in a trial phase as we work through some outstanding
      licensing and ownership questions. This trial period will allow us to
      thoroughly evaluate the platform's compatibility with our existing systems
      and address any legal and operational considerations. Once these issues
      are clarified and resolved, we plan to roll out Matomo across all teams to
      ensure a smooth and compliant integration.
    ring: adopt
    active: true
    moved: 2
  - label: PHP/Pie
    description: >
      <a href="https://github.com/php/pie"PHP/>Pie</a> is an innovative
      extension to the PHP ecosystem that provides a streamlined, modular
      framework for building web applications. It enhances PHP’s native
      capabilities by offering intuitive tools and a flexible architecture,
      helping developers write cleaner, more maintainable code and accelerate
      project delivery.

      PHP/Pie is currently in a trial phase as we assess its performance and
      gather initial user feedback. Teams interested in taking part in the trial
      phase are encouraged to reach out to Team ArCo for more details and
      onboarding support.
    ring: adopt
    active: true
    moved: 2
  - label: Grafana k6
    description: >
      <a href="https://k6.io">Grafana k6</a> is a modern load testing tool that
      allows teams to simulate high-traffic scenarios and evaluate system
      performance under stress. Its scriptable testing environment and clear
      reporting capabilities make it an effective solution for identifying
      performance bottlenecks.

      Teams are encouraged to adopt Grafana k6 to proactively optimize
      application performance. Its robust testing features help ensure that
      systems remain responsive and reliable even under demanding load
      conditions.
    ring: adopt
    active: true
    moved: 2
  - label: Product Fruits
    description: >
      <a href="https://productfruits.com">Product Fruits</a> is an AI-powered
      product adoption platform that helps create user onboarding experiences
      through smart product tours, interactive guides, and personalized
      assistance.

      Teams are encouraged to adopt Product Fruits to improve user onboarding
      and reduce support tickets. Its AI-driven approach helps turn confused
      visitors into confident users by providing contextual guidance and
      reducing time to activation.
    ring: adopt
    active: true
    moved: 2
  - label: Google Gemini
    description: >
      <a href="https://gemini.google.com">Google Gemini</a> is an advanced
      generative AI system developed by Google, designed to leverage multimodal
      capabilities—combining natural language processing, computer vision, and
      reasoning—to deliver innovative, integrated solutions.

      Teams are encouraged to adopt Google Gemini for AI-powered development
      tasks, content generation, and problem-solving. Its multimodal
      capabilities and integration with Google's ecosystem make it a valuable
      tool for enhancing productivity and innovation.
    ring: adopt
    active: true
    moved: 2
  - label: GitHub Copilot
    description: >
      <a href="https://github.com/features/copilot">GitHub Copilot</a> is an
      AI-powered code completion tool that assists developers by providing
      context-aware code suggestions and autocompletions, helping to accelerate
      coding and reduce routine work.

      We decided to hold off on adopting GitHub Copilot for now due to the
      decision to move towards Claude Code.
    ring: onHold
    active: true
    moved: 2
  - label: Playwright MCP
    description: >
      <a href="https://github.com/microsoft/playwright-mcp">Playwright MCP</a>
      is a Model Context Protocol server that provides browser automation
      capabilities using Playwright, enabling LLMs to interact with web pages
      through structured accessibility snapshots.

      We are found Playwright MCP pretty helpful for AI-powered browser
      automation and testing workflows, providing a fast and deterministic
      approach to web interaction.
    ring: adopt
    active: true
    moved: 0
  - label: LocalStack
    description: >
      <a href="https://www.localstack.cloud/">LocalStack</a> is a cloud
      development tool that emulates AWS and Snowflake services locally,
      enabling faster development, testing, and iteration without accessing
      actual cloud resources.

      We are betting on LocalStack as part for our local development workflows,
      reducing cloud costs, and enabling faster feedback cycles during
      development. It also became the replacement for local S3 storage, formerly
      MinIO
    ring: adopt
    active: true
    moved: 0
  - label: Claude Code
    description: >
      <a href="https://docs.claude.com/en/docs/claude-code/overview">Claude
      Code</a> is an agentic coding tool that lives in your terminal, helping
      turn ideas into code faster by understanding your codebase, editing files
      directly, running commands, and handling git workflows through natural
      language.

      It's where the innovation happens. Claude Code is at the forefront of
      AI-assisted development.  Rather than spreading our bets across multiple
      tools,  we're backing the one that consistently pushes the boundary of
      what's possible.
    ring: adopt
    active: true
    moved: 0
  - label: vitest
    description: >
      <a href="https://vitest.dev/">Vitest</a> is a next generation testing
      framework powered by Vite, offering a fast, modern testing experience with
      Jest-compatible APIs, smart watch mode, and out-of-the-box support for
      TypeScript, JSX, and ESM.

      We are currently trialing Vitest as a modern alternative to Jest,
      particularly for Vite-based projects. Its native Vite integration and
      improved performance make it a promising option for testing TypeScript
      applications.
    ring: trial
    active: true
    moved: 2
  - label: OpenTofu
    description: >
      <a href="https://opentofu.org/">OpenTofu</a> is an open-source,
      community-driven infrastructure as code tool that serves as a drop-in
      replacement for Terraform, providing the same workflows while remaining
      truly open source under the Linux Foundation.

      We are currently assessing OpenTofu as an alternative to Terraform,
      particularly in light of recent licensing changes. Its commitment to
      open-source principles and community-driven development makes it a
      compelling option for infrastructure management.
    ring: assess
    active: true
    moved: 2
  - label: chrome-dev-tools-mcp
    description: >
      <a href="https://github.com/ChromeDevTools/chrome-devtools-mcp">Chrome
      DevTools MCP</a> is a Model Context Protocol server that allows AI coding
      agents to control and inspect a live Chrome browser, providing performance
      insights, debugging capabilities, and browser automation.

      We are currently assessing chrome-dev-tools-mcp to evaluate its potential
      for AI-powered browser debugging, performance analysis, and automated
      testing workflows.
    ring: assess
    active: true
    moved: 2
  - label: AWS Q Developer
    description: >
      <a href="https://aws.amazon.com/q/developer/">AWS Q Developer</a> is a
      generative AI-powered assistant for software development that helps build
      faster by autonomously performing tasks like implementing features,
      documenting, testing, reviewing, and refactoring code.

      We are currently assessing AWS Q Developer to evaluate its potential for
      enhancing development workflows, particularly for AWS-based applications
      and cloud infrastructure tasks.
    ring: onHold
    active: true
    moved: 4
  - label: JetBrains AI Assistant
    description: >
      <a href="https://www.jetbrains.com/ai/">JetBrains AI Assistant</a> is an
      AI-powered tool designed to integrate with JetBrains IDEs, offering
      context-aware code suggestions, refactoring support, and productivity
      enhancements.

      JetBrains AI Assistant is currently on hold as we evaluate alternative AI
      coding tools and assess which solutions best align with our development
      workflows and productivity goals. Main driver to put this on hold is the
      pricing model and token allowance.
    ring: onHold
    active: true
    moved: 2
  - label: AWS Agent Plugin
    description: >
      <a href="https://github.com/awslabs/agent-plugins/tree/main">AWS Agents
      Plugin</a>  equip AI coding agents with the skills to help you architect,
      deploy, and operate on AWS

      It helps the agent to recommend better AWS architectures and services,
      estimating costs,  generating Infrastructure as Code (CDK or
      CloudFormation), and guiding you through deployment.
    ring: assess
    active: true
    moved: 0
